import { mixpanelTrack } from "./mixpanelTrack";

const SECTION = "Meta Rating";

/**
 * The link out of the badge's hover explanation, to /meta-rating. The badge
 * rides on cards all over the site, so the page it was clicked from comes from
 * the SDK's own `$current_url` rather than a prop threaded through every card.
 */
export const trackMetaRatingLearnMore = () =>
  mixpanelTrack("learn_more", {
    section: SECTION,
    context: "badge_tooltip",
    action_type: "browse",
  });
